import fecha from 'fecha';

export function dateOnly(dateStr) {
  return fecha.format(Date.parse( dateStr ), 'YYYY-MM-DD');
}